// Put your Javascript here - You can use ES2015 Javascript, because we use Webpack with Babel
require('./../Sass/base.scss');

// Require babel polyfill before anything else so stupid IE can handle modern stuff like Symbols etc.
require('babel-polyfill');

import {faPlayCircle} from "@fortawesome/pro-solid-svg-icons/faPlayCircle";
import {faSearch} from "@fortawesome/pro-light-svg-icons/faSearch";
import {faHeart} from "@fortawesome/pro-solid-svg-icons/faHeart";
import {faCommentAlt} from "@fortawesome/pro-solid-svg-icons/faCommentAlt";
import {faBell} from "@fortawesome/pro-solid-svg-icons/faBell";
import {faUser} from "@fortawesome/pro-solid-svg-icons/faUser";

import {dom, library} from "@fortawesome/fontawesome-svg-core";

import * as helper from './../../../../../VX/View/Assets/Js/helper';
import {initAnmeldung} from "./Anmeldung";
import {initChat} from "./Chat";
import {initPeople} from "./People";
import {initFakeChatters} from "./FakeChatters";
import {initImprint} from "../../../Assets/Js/VXImprint";
import {initDialogHandler} from "./DialogHandler";
import SignupHandler from "./SignupHandler";
import * as Events from "./Events";

helper.onDocumentLoaded(() => {
	library.add(faPlayCircle, faSearch, faHeart, faCommentAlt, faBell, faUser);
	dom.watch();

	const intro = helper.$('#intro');
	const chat = helper.$('#chatroom');
	const anmeldung = helper.$('#anmeldung');
	const people = helper.$('#people');
	new SignupHandler();

	// Delegated event listener for all the paytour links
	helper.addClickListener(document, (e: MouseEvent) => {
		const target = e.target as Element;
		const closest = target.closest('.paytour');
		if (!closest) {
			return;
		}

		e.preventDefault();
		const id = helper.getData(closest, 'hostid');

		helper.triggerEvent(window, Events.CREATE_SIGNUP, {id})
	});

	helper.wait(3)
		.then(() => {
			helper.fadeOut(intro)
				.then(() => {
					helper.hide(intro);
				});
			helper.show(chat, 'flex');
			helper.show(anmeldung);
			helper.fadeInAll([chat, anmeldung])
		})

	initAnmeldung(anmeldung);
	initChat(chat);
	initPeople(people);
	initFakeChatters()
	initImprint(helper.$('#impressumlink'), helper.$('#datenschutzlink'));
	initDialogHandler();
})
